module.exports = __webpack_public_path__ + "media/images/header_pc-3e99aa1c359060be8a1c924526cc11f9.jpg";